import { PayloadAction } from '@reduxjs/toolkit'
import { actions as resultsProviderV2Actions } from 'astra-core/containers/ResultsProviderV2/slice'
import { UpdateResultsPayload } from 'astra-core/containers/ResultsProviderV2/types'
import { CompletionStatus, Tournament } from 'betweb-openapi-axios'
import { all, put, takeEvery } from 'redux-saga/effects'

import { eventResultsContainerActions } from './slice'
import { TournamentOption } from './types'

function* updateTournamentsList(action: PayloadAction<UpdateResultsPayload>) {
  const { eventResults } = action.payload
  const ids: Tournament['id'][] = []
  const tournamentOptionById: Record<Tournament['id'], TournamentOption> = {}

  eventResults.forEach((eventResult) => {
    const { tournament } = eventResult
    tournamentOptionById[tournament.id] = {
      value: String(tournament.id),
      label: tournament.name,
      isLive:
        tournamentOptionById[tournament.id]?.isLive ||
        eventResult.completionStatus === CompletionStatus.Live
    }
    ids.push(tournament.id)
  })

  yield put(
    eventResultsContainerActions.updateTournamentOptions({
      ids,
      tournamentOptionById
    })
  )
}

export function* rootSaga() {
  yield all([
    yield takeEvery(
      resultsProviderV2Actions.updateEventResults.type,
      updateTournamentsList
    )
  ])
}
